import React from "react";
import { useSelector } from "react-redux";

import winLogo from "./../../assets/images/logo-win.svg";
import ffbLogo from "./../../assets/images/highmark/ffb-logo.jpg";
import { t } from "i18next";
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from '../Layout/ChatContext';

const Benefits_PatientID = () => {
    // Access userData from Redux state
    const contract = useSelector((state) => state.userData);
    const phoneNumber = contract.userData?.PhoneNumber || "(855)7054483"; // Fallback if PhoneNumber is unavailable
    // Destructure required fields from contract.userData
    const { FirstName, LastName, EmailID, Employer, MemberID } = contract.userData || {};
    const {isChatVisible, toggleChat, showChat } = useChat();

    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";

    return (
        <>

            {isHighmarkPortal ? 
                <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
                <button className="win-back-btn" onClick={() => window.history.back()}>
                    <span>
                    <i className="bi bi-chevron-left"></i>
                    </span>
                </button>       
                <h2 className="page-heading win-patient-id">FFB {t('id')}</h2>
                </div>:
                <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
                <button className="win-back-btn" onClick={() => window.history.back()}>
                    <span>
                    <i className="bi bi-chevron-left"></i>    
                    {t('Back')}        
                    </span>
                </button>       
                <h2 className="page-heading win-patient-id"><img src={winLogo} height="28px" alt="" /> {t('id')}</h2>
                </div>
            }

            {/* <div className="col-12 mt-4 inner-page-heading-wrapper">
                <button
                    className="win-back-btn me-3"
                    onClick={() => window.history.back()}
                >
                    <span>
                        <i className="bi bi-chevron-left"></i> {t('back')}
                    </span>
                </button>
                <h1 className="page-heading win-patient-id"><img src={winLogo} height="28px" alt="" /> {t('id')}</h1>
            </div> */}

            <div className="col-md-12 mt-4">

                <div className="win-id-card-wrapper mt-0">

                    <div class="win-id-card-header">

                    {isHighmarkPortal ? 
                        <div className="ffb-id-card-logo-wrapper">
                            <img src={ffbLogo} alt="" className="ffb-id-logo" />
                        </div>
                        :
                        <div className="win-id-card-logo-wrapper">
                            <img src={winLogo} alt="" className="win-id-logo" />
                        </div>
                    }
                        
                        <div class="win-id-card-details-wrapper">
                            <p class="card-details"><span className="card-details-label">{t('name')}:</span> <span className="card-details-value">{`${FirstName || "N/A"} ${LastName || "N/A"}`}</span></p>
                            <p class="card-details"><span className="card-details-label">{t('mywinid')}:</span> <span className="card-details-value">{MemberID || "N/A"}</span></p>
                            {/* <p class="card-details"><span className="card-details-label">Email:</span> <span className="card-details-value">{EmailID || "N/A"}</span></p> */}
                            <p class="card-details"><span className="card-details-label">{t('company')}:</span> <span className="card-details-value">{Employer || "N/A"}</span></p>
                        </div>

                    </div>
                    <div class="win-id-card-footer">
                        <span class="card-questions">{t('havequestions')}</span>
                        <br />
                        <span class="card-contact">{phoneNumber}</span>
                    </div>

                </div>


                <div className="win-atm-card-wrapper mt-5" style={{display: "none"}}>

                    <div class="card-content">

                        <div class="card-header">
                            <p class="card-details"><span className="card-details-label">{t('name')}:</span> <span className="card-details-value">{`${FirstName || "N/A"} ${LastName || "N/A"}`}</span></p>
                            <p class="card-details"><span className="card-details-label">{t('mywinid')}:</span> <span className="card-details-value">{MemberID || "N/A"}</span></p>
                            {/* <p class="card-details"><span className="card-details-label">Email:</span> <span className="card-details-value">{EmailID || "N/A"}</span></p> */}
                            <p class="card-details"><span className="card-details-label">{t('company')}:</span> <span className="card-details-value">{Employer || "N/A"}</span></p>
                        </div>

                        <div class="card-footer">
                            <span class="card-questions">{t('havequestions')}</span>
                            <span class="card-contact">{phoneNumber}</span>
                        </div>

                    </div>

                </div>

            </div>

            <div className="col-md-6 mt-4">
                {/* <b>{t('havequestions')}</b>
                <br />
                <h3 className="page-heading">{t('phonenumber1')}</h3> */}
            </div>
            {/* {isChatVisible && <ChatBotWindow />} */}
        </>
    );
};

export default Benefits_PatientID;
